import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import axios from 'axios';
// material
import {
  Typography,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import liff from '@line/liff';
import SimpleSnackbar from '../SimpleSnackbar'
// ----------------------------------------------------------------------

const host ="https://api.smartbustw.com/";

export default function BingFrom({ cityobj }) {
  const [liffInitialized, setLiffInitialized] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmit, setisSubmit] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (cityobj && cityobj.liffId) {
      liff.init({
        liffId: cityobj.liffId,
      })
        .then(() => {
          // Start to use liff's api
          setLiffInitialized(true);
        })
        .catch((err) => {
          // Error happens during initialization
          console.log(err.code, err.message);
        });
    }
  }, [cityobj]);

  const apiHexSchool = axios.create({
    baseURL: `${host}/api/line`,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
  });

  const navigate = useNavigate();

  const LoginSchema = Yup.object().shape({
    id: Yup.string().required('必填'),
    password: Yup.string().required('必填')
  });

  const onSubmit = async (values, actions) => {
    if(values.member === "true")
      values.member=true
    else
      values.member=false
    
    // setisSubmit(true);
   /* setTimeout(() => {
      // alert(JSON.stringify(values,null,2));
      setisSubmit(false);
    }, 2000) */

    values.lineid = liff.getContext().userId

    values.region= cityobj.region;

    // eslint-disable-next-line no-unused-vars, prefer-const
    let jsonstr=JSON.stringify(values);
    setisSubmit(true);
    apiHexSchool.post('/bind', JSON.stringify(values))
      .then((response) => 
      {
        if (typeof response.data.code === "number") 
        {
          if (response.data.code === 0) {
            setOpen(true);
            setTimeout(() => { liff.closeWindow() }, 2000);
          }
          else
            alert(response.data.message)
        } else {
          alert("連線錯誤")
        }
        setisSubmit(false);
      }
      )
      .catch((error) => console.log(error))
  };

  const formik = useFormik({
    initialValues: {
      lineid: '',// id
      region: cityobj.region,
      id: '',
      password: '',
      member: false
    },
    validationSchema: LoginSchema,
    onSubmit: (values, actions) => onSubmit(values, actions)
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="text"
            label="請輸入身分證字號"
            {...getFieldProps('id')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="請輸入密碼"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
           <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">請勾選身份</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              
              name="radio-buttons-group"
              {...getFieldProps('member')}
            >
              <FormControlLabel value='false' control={<Radio />}    label={`「我是本人」${cityobj.bindmyself ? `， ${cityobj.bindmyself}` : ""}。`} />
              <FormControlLabel value='true' control={<Radio />}   label={`我是家屬${cityobj.bindfamily ? `， ${cityobj.bindfamily}` : ""}。`} />
            </RadioGroup>
          </FormControl>
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmit}
            disabled={!liffInitialized} // Disable button until liff is initialized
          >
            綁定
          </LoadingButton>
        </Stack>
       
        
   
        <Stack>
          <div style={{ 'margin': '10px' }} >
            <p>*符合乘車資格且尚未註冊【{cityobj.organization}】者，請至官網註冊（以下連結），審核通過後始能進行帳號綁定。</p>

            點我註冊：<a href={cityobj.webbookingurl} target="_blank" rel='noreferrer'  >{cityobj.webbookingurl}</a>
          </div>
        </Stack>
        <Stack>
          <div style={{ 'margin': '10px' ,'color':'red'}} >
            <p>*請勿在Line官方帳號內傳送任何申請證件或圖片。</p>            
          </div>
        </Stack>
        
      </Form>
      <SimpleSnackbar open={open} setOpen={setOpen} message="綁定成功!自動關閉中..." />
    </FormikProvider>
  );
}
